import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as MySound from '../../MySound';

export class RF_Pick extends Component {
    static displayName = RF_Pick.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            namecode: "",
            createdDocket: 0,
            loading:true,
            fromLocationBarcode: "",
            fromLocationId: "",
            inventoriesOnFromLocation: [],
            fromLocation: "",
            hasFromLocationLoaded: false,
            scannedProductBarcode: "",
            scannedInventory: "",
            clientName:""

        }
    }

    componentDidMount() {
        if (MyGlobal.rf_transfer) {
            var rf_transfersettings = JSON.parse(MyGlobal.rf_transfer);
            if (rf_transfersettings) {
               
                this.state.fromLocationId = rf_transfersettings.fromLocationId;
                this.state.fromLocationBarcode = rf_transfersettings.fromLocationBarcode;
                this.state.createdDocket= rf_transfersettings.createdDocket;
                this.state.namecode = rf_transfersettings.namecode;
                this.state.clientName = rf_transfersettings.clientName;
                if (rf_transfersettings.fromLocationBarcode) {
                    this.loadFromLocationInventories();
                }
            }
        }
    }
  
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    async loadFromLocationInventories() {
        if (this.state.fromLocationBarcode == "") {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Enter a valid Location barcode to load the Stock from" });
            return;
        }

        
        var warehouseID = MyGlobal.warehouse;
        this.state.loading = true;
        fetch(`api/Transfer/GetInventoryLines?barcodeText=${this.state.fromLocationBarcode}&warehouseID=${warehouseID}`)
            .then(async response => {


                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    MySound.play(MySound.Sound.stop);
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Cannot load Stock. " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ inventoriesOnFromLocation: data.inventoriesOnTransferFromLocation, fromLocation: data.locationId, hasFromLocationLoaded: true });
                            if (!this.state.inventoriesOnFromLocation || this.state.inventoriesOnFromLocation.length === 0) {
                                MySound.play(MySound.Sound.stop);
                                this.setState({ alertMessage: "This location does not contain inventory. Cannot start transfer here" });
                                return;
                            }
                            this.refs.productBarcodeInputOut.focus();
                        }
                        else {
                            MySound.play(MySound.Sound.stop)
                            this.setState({ alertMessage: "Failed to load inventories!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        MySound.play(MySound.Sound.stop)
                        this.setState({ alertMessage: "Failed to load inventories!!" });
                    }

                }

            })
            .catch(error => {
                MySound.play(MySound.Sound.stop)
                this.setState({ inventoriesOnFromLocation: [], alertMessage: error });
            });
    }
    moveInventoryOut(inventory) {
        if (this.state.createdDocket > 0 && this.state.namecode && this.state.namecode !== inventory.namecode) {
            this.setState({ alertMessage: "You can only transfer one customers products per transfer", scannedProductBarcode: "" });
            return;
        }
        var scannedBarcode = inventory.barcode;
        this.setState({ alertMessage: "" });
        if (!scannedBarcode) {
            this.setState({ alertMessage: "Barcode cannot be empty", scannedProductBarcode:"" });
            return;
        }
        this.setState({ scannedProductBarcode: scannedBarcode, clientName: inventory.clientName });
        return;
    }
    renderTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Barcode</th>
                        <th>Description</th>
                        {/*<th>Grade1</th>*/}
                        {/*<th>Grade2</th>*/}
                        {/*<th>Grade3</th>*/}
                        <th>PackingDate</th>
                        <th>ExpiryDate</th>
                        <th>Units</th>
                        <th>Commited</th>
                        <th>Client</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) =>
                        <tr key={index} onClick={() => { this.moveInventoryOut(row) }}>
                            <td>{row.productCode}</td>
                            <td>{row.barcode}</td>
                            <td>{row.productDescription}</td>
                            {/*<td>{row.grade1}</td>*/}
                            {/*<td>{row.grade2}</td>*/}
                            {/*<td>{row.grade3}</td>*/}
                            <td>{row.packingDate ? new Date(row.packingDate).toLocaleDateString() : ''}</td>
                            <td>{row.expiryDate ? new Date(row.expiryDate).toLocaleDateString() : ''}</td>
                            <td>{row.units}</td>
                            <td>{row.committedUnits}</td>
                            <td>{row.clientName}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    validateScannedProductCode() {

        if (!this.state.scannedProductBarcode) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please scan the Product barcode" });
            return;
        }
        this.state.scannedProductBarcode = this.state.scannedProductBarcode.trim().toUpperCase();
        if (!this.state.inventoriesOnFromLocation || this.state.inventoriesOnFromLocation.length <= 0) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "There are no inventories loaded" });
            return;
        }
        var scannedProductBarcode = this.state.scannedProductBarcode;
        const inventory = this.state.inventoriesOnFromLocation.find((element) => {
            return element.barcode === scannedProductBarcode;
        });
        if (!inventory) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Inventory with barcode: " + scannedProductBarcode + " not found in the list of inventories for this location" });
            return;
        }
        MySound.play(MySound.Sound.next);
        this.state.scannedInventory = inventory;
        this.goto('RF_ConfirmPick'); 
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let inventoryContentsFromLocation = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.inventoriesOnFromLocation);

        const handleInputKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateScannedProductCode();
            }
        };

        return (
            <div>
                <Container>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('RF_AdhocTransfer'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><h4>Location : {this.state.fromLocationBarcode}</h4></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><b> {this.state.transferCreatedBy} </b></Col>
                        <Col><b> {this.state.transferUpdatedBy} </b></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={6}>
                            <label>Client : {this.state.clientName}</label>
                        </Col>
                        <Col xs={6}>
                            <label>Docket : {this.state.createdDocket}</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><label>Select Product :</label></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="productBarcodeInputOut" className="form-control" placeholder="Enter Product Barcode"
                                value={this.state.scannedProductBarcode}
                                onChange={(e) => {
                                    this.setState({ scannedProductBarcode: e.target.value });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleInputKeypress} ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-success col-12" onClick={() => { this.validateScannedProductCode(); }}  >Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}> <h5> Available Inventory </h5></Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {inventoryContentsFromLocation}
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        );
    }
}